import styled from '@emotion/styled'
import Title from '@atoms/Title'

export const StyledTitle = styled(Title)`
  font-size: ${({ theme }) => theme.text.h4.fontSize};
  line-height: ${({ theme }) => theme.text.h4.lineHeight};
`
